import React, { memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { BadgeButton } from '../../../../../components/BadgeButton/BadgeButton';
import { RadioCircle } from '../../../../../components/RadioCircle/RadioCircle';
import { SeparatorLine } from '../../../../../components/SeparatorLine/SeparatorLine';
import { useLanguage } from '../../../../../locale/useLanguage';
import { Routes } from '../../../../../routes/types';

import './AddressElement.css';

type AddressElementProps = {
  addressId: number;
  addressType: string;
  addressName: string;
  addressFirstPart: string;
  addressSecondPart: string;
  isSelected?: boolean;
  onClick?: () => void;
};

export const AddressElement: React.FC<AddressElementProps> = memo(
  ({
    addressId,
    addressFirstPart,
    addressName,
    addressSecondPart,
    addressType,
    isSelected,
    onClick,
  }) => {
    const [t] = useLanguage();
    const history = useHistory();

    const onEdit = useCallback(() => {
      history.replace(Routes.EditAddress.replace(':addressId', `${addressId}`));
    }, [addressId, history]);

    return (
      <>
        <div
          onClick={onClick}
          role="option"
          className="address-element--container"
        >
          <div className="address-element--address-container">
            <p className="address-element--address-type">{addressType}</p>
            <h2 className="address-element--title">{addressName}</h2>
            <p className="address-element--address">{addressFirstPart}</p>
            <p className="address-element--address">{addressSecondPart}</p>
            <div className="address-element--badge-container">
              <BadgeButton
                onClick={onEdit}
                isPrimary
                label={t('chooseFavoriteAddress.edit')}
              />
            </div>
          </div>
          <div className="address-element--circle-container">
            <RadioCircle isSelected={isSelected} />
          </div>
        </div>
        <SeparatorLine />
      </>
    );
  }
);
